import { Component, OnInit, Inject } from '@angular/core';
import {ReportsService} from './reports.service';
import {AppService} from '../shared/services/app.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-cutlog',
  templateUrl: './cutlog.component.html'
})
export class CutlogComponent implements OnInit {

  results:any[];
  rForm: FormGroup;

  constructor(
    private _reportsService: ReportsService,
    private _appService: AppService,
    @Inject(FormBuilder) fb: FormBuilder
  ){
    this.rForm = fb.group({
      startDate: [null],
      endDate: [null]
    })
  }

  ngOnInit() {
    this._appService.hideLoader();

  }

  getCutLog() {
    this._reportsService.getCutLog(this.rForm.value).subscribe(
      data => this.results = data.results,
      error => console.log(error),
      () => {
        this._appService.hideLoader();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/cutlog.component.ts